<template>
    <AppJumbotron without-tyres>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
            <div>
                <h1 class="text-white mb-4 text-3xl lg:text-4xl xl:text-5xl tracking-wide">
                    Find reviews for
                    <span class="font-bold">{{ manufacturer.name }} car tyres</span>
                    at {{ config.name }}
                </h1>


                <p class="text-white mb-4">
                    <span class="font-bold inline-block md:block">{{ manufacturer.reviews_count }} reviews</span>
                    for {{ manufacturer.name }} car tyres
                </p>

                <!--                <AppButton v-if="manufacturer.reviews_count > 0" theme="secondary" href="#">-->
                <!--                    Read Reviews-->
                <!--                </AppButton>-->
            </div>
            <div v-if="modelImage" class="hidden md:block">
                <img class="max-h-60 lg:max-h-80" :src="modelImage">
            </div>
        </div>
    </AppJumbotron>

    <AppContainer>
        <template v-if="models.length > 0">
            <ManufacturerTyreBrands
                :manufacturer="manufacturer"
                :brands="brands"
                :loading="brandsLoading"
            ></ManufacturerTyreBrands>

            <PopularManufacturerModels class="mt-4"
                                       :manufacturer="manufacturer"
                                       :models="popularModels"></PopularManufacturerModels>

            <AllManufacturerModels class="mt-4" :manufacturer="manufacturer" :models="models"></AllManufacturerModels>
        </template>

        <p class="py-16 text-center" v-else>
            We don't have any tyre reviews associated with {{ manufacturer.name }} vehicles on record.
        </p>
    </AppContainer>

    <FooterDisclaimer v-if="manufacturer.description" class="mt-4" :title="`${manufacturer.name} Cars`">
        <div v-html="manufacturer.description"></div>
    </FooterDisclaimer>
</template>

<script>
import {Head, useForm} from "@inertiajs/inertia-vue3";
import AppJumbotron from "@/Components/AppJumbotron";
import AppButton from "@/Components/AppButton";
import AppContainer from "@/Layouts/AppContainer";
import ManufacturerTyreBrands from "@/Components/Manufacturers/ManufacturerTyreBrands";
import PopularManufacturerModels from "@/Components/Manufacturers/PopularManufacturerModels";
import AllManufacturerModels from "@/Components/Manufacturers/AllManufacturerModels";
import FooterDisclaimer from "@/Components/DisclaimerBar";
import MainLayout from "@/Layouts/MainLayout";
import AppHead from "@/Components/AppSeoTags";

export default {
    components: {
        AppHead,
        FooterDisclaimer,
        AllManufacturerModels,
        AppContainer, AppButton, AppJumbotron, ManufacturerTyreBrands, PopularManufacturerModels, Head
    },
    props: {
        manufacturer: Object,
        models: Array,
        popularModels: Array,
        config: Object,
        // brands: Array,
        seoTags: Object
    },
    data() {
        return {
            brands: [],
            brandsLoading: true
        };
    },
    mounted() {
        this.getBrands();
    },
    computed: {
        modelImage() {
            if (this.popularModels.length === 0) return null;

            const firstModel = this.popularModels[0];

            return firstModel.image;
        }
    },
    methods: {
        async getBrands() {
            const response = await axios.get(this.route("manufacturers.brands.index", this.manufacturer));

            this.brands = response.data;
            this.brandsLoading = false;
        }
    }
};
</script>

<style scoped>

</style>
